import { render, staticRenderFns } from "./store-config.vue?vue&type=template&id=763879a3"
import script from "./store-config.vue?vue&type=script&lang=js"
export * from "./store-config.vue?vue&type=script&lang=js"
import style0 from "./store-config.vue?vue&type=style&index=0&id=763879a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports